import { IBaseFormBuilder } from '../builders/base-builder.class';

export class OtpStepDirector {
    constructor(private builder: IBaseFormBuilder) { }

    make(dataFormValue: any = {}) {
        this.builder.build(dataFormValue);
    }
}